
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
    flex-direction: column;
    gap: 2px;
    margin-left: 25px;
    margin-right: 5px;
  box-sizing: border-box;
`;
export const Container = styled.div`
  display: flex;
  gap: 30px;
  height: 380px;
  margin-bottom:20px;
`;

export const ChildContainer2 = styled.div`
  flex: 1;
  height: 100%;
  border-radius: 15px;
  border: 1px solid #d9d9d9;

  justify-content: center;
  align-items: center;
  box-sizing: border-box;
`;
export const ChildContainer = styled.div`
  flex: 1;
  height: 100%;
  border-radius: 15px;
  border: 1px solid #d9d9d9;

  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
`;
export const FilterContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  border-radius: 15px;
  border: 1px solid #d9d9d9;
  /* justify-content: center; */
  /* align-items: center; */
  box-sizing: border-box;
  padding: 5px;

  span {
    color: #636363;
  font-family: inherit;
    font-size: 15px;
    font-weight: 500;

    justify-content: space-between;
    align-items: center;
    margin: 10px 0px 0px 10px;
  }

  div {
    margin: 10px 0px 0px 0px;
  }
`;